import React, { useEffect, useRef } from 'react'

// Lightweight toast. The old MUI (Snackbar + Alert + makeStyles) implementation
// was already commented out and replaced by this plain div render; the dead
// imports are dropped here so nothing pulls @material-ui in. Styling is Tailwind
// (was Bootstrap: text-bg-success/danger, d-flex, position-fixed, toast-body).
const SnackBarComponent = (props) => {
  const { showNotification, notification, closeNotifier } = props
  const { message, type } = notification
  const ref = useRef(null)

  useEffect(() => {
    if (!showNotification) return
    clearTimeout(ref)
    ref.current = setTimeout(() => {
      closeNotifier()
    }, 6000)
  }, [showNotification, closeNotifier])

  if (!showNotification) return null

  return (
    <div className="w-full fixed bottom-16 z-50 left-2">
      <div
        className={`${
          type === 'success' ? 'bg-green-600' : 'bg-red-600'
        } text-white rounded p-3 w-max max-w-[92vw]`}
      >
        <div className="flex items-center">
          <div className="break-words">{message}</div>
          <button
            onClick={closeNotifier}
            type="button"
            className="ml-4 text-[16px]"
          >
            X
          </button>
        </div>
      </div>
    </div>
  )
}

export default SnackBarComponent
